import { Entities, SET_ENTITIES, SetEntitiesAction } from './types'

export const setEntities = (entities: Entities): SetEntitiesAction => ({
  type: SET_ENTITIES,
  payload: entities
})
